import { Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import WhatsAppWidget from "./components/WhatsAppWidget";
import ServicePage from "./pages/ServicePage";
import InfoPage from "./pages/InfoPage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/servicios/:serviceId" element={<ServicePage />} />
        <Route path="/info/:infoId" element={<InfoPage />} />
      </Routes>
      <WhatsAppWidget />
    </>
  );
}

export default App;